module.exports = require("@seddi/three/addons/postprocessing/Pass.js");